@layer components {
    .items {
        pointer-events: none;
        position: fixed;

        > * {
            pointer-events: auto;
        }

        .default-item {
            position: absolute;
        }

        > *,
        .default-item {
            translate: -50% -50%;
        }
    }
}
